/**
 * The "as of" line, Refresh button and error for Cold Link's on-hand (Copeland
 * 2026-10-29). Renders nothing at an unflagged area.
 *
 * An unreadable BC is said so, in words, and no row shows a number — never a
 * zero standing in for "could not read".
 */
export interface OnHandBarProps {
  flagged: boolean;
  asOf: string | null;
  loading: boolean;
  error: string | null;
  onRefresh: () => void;
}

export function formatAsOfEt(iso: string): string {
  const when = new Date(iso);
  if (Number.isNaN(when.getTime())) return iso;
  return `${new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/New_York",
  }).format(when)} ET`;
}

export function OnHandBar({ flagged, asOf, loading, error, onRefresh }: OnHandBarProps) {
  if (!flagged) return null;
  return (
    <div className="card notice small" data-testid="bc-bar">
      <strong>BC on hand is shown at this area.</strong> The freezer portal lags
      Business Central, so compare before you type — it never fills the box for you.{" "}
      {asOf && !error && <span data-testid="bc-asof">as of {formatAsOfEt(asOf)}</span>}{" "}
      <button type="button" onClick={onRefresh} disabled={loading} data-testid="bc-refresh">
        {loading ? "Reading…" : "Refresh"}
      </button>
      {error && (
        <p className="error-text" role="alert" data-testid="bc-error">
          Could not read BC on hand: {error}. No quantity is shown — counting is not blocked.
        </p>
      )}
    </div>
  );
}
